import { createRouter, createWebHistory } from 'vue-router';
import ProductsComponent from './components/ProductsComponent.vue';
import ProductDetails from './ProductDetails.vue';
import NotFound from './NotFound.vue';
import NosotrosPage from './NosotrosPage.vue';

const routes = [
  { path: '/', component: ProductsComponent },
  { path: '/product/:name', component: ProductDetails },
  { path: '/nosotros', component: NosotrosPage },
  { path: '/:pathMatch(.*)*', component: NotFound }, 
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;